import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Confirmation modal shown when the user tries to navigate away with unsaved changes.
 *
 * Opened imperatively via `NgbModal.open(UnsavedChangesModalComponent)`.
 * Closes with result `'save'` or `'discard'`, or is dismissed with `'cancel'`.
 */
@Component({
  selector: 'app-unsaved-changes-modal',
  standalone: true,
  imports: [],
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrl: './unsaved-changes-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesModalComponent {
  protected readonly activeModal = inject(NgbActiveModal);

  protected save(): void {
    this.activeModal.close('save');
  }

  protected discard(): void {
    this.activeModal.close('discard');
  }

  protected cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}
